import link from "@/scripts/host.js";
import loggedIn from '@/scripts/logged.js'
import handleError from '@/scripts/handleError.js'


export default {
  name: "ChangeMail",
  props: ["close"],
  data() {
    return {
      newEmail: "",
      repeatEmail: "",
      invalid: false
    };
  },
  methods: {
    closeModal() {
      this.$store.dispatch("toggleLoginModal");
    },
    checkEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },

    async changeEmail() {
      let token = await loggedIn();

      if (
        !this.checkEmail(this.newEmail) ||
        !this.checkEmail(this.repeatEmail) ||
        this.newEmail !== this.repeatEmail
      ) {
        this.invalid = true;
      } else {
        this.axios({
          method: "post",
          url: `${link.hostLink}Account/Update`,
          data: { email: this.newEmail },
          headers: {authorization: `bearer ${token}`}

        })
          .then(() => {
            this.$store.dispatch('setGenericModalText', 'Adres e-mail został pomyślnie zmieniony.');

            this.$store.dispatch('setModalType', 'genericModal');

          })
          .catch(function(error) {
            handleError(error.response);
          });
        this.invalid = false;
      }
    }
  },

  mounted() {}
}
